import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class Document extends DomainObject {
  createdAt;
  fileName;
  contentType;
  shareWithEmployee;
  canShare;
  fileUrl;
  fileSize;
  fileType;
  key;
  folder;
  category;

  constructor(other) {
    super();

    makeObservable(this, {
      createdAt: observable,
      fileName: observable,
      contentType: observable,
      shareWithEmployee: observable,
      canShare: observable,
      fileUrl: observable,
      fileSize: observable,
      fileType: observable,
      key: observable,
      folder: observable,
      category: observable
    });

    this.merge(other);
  }
}

export default Document;
